import { styled } from 'styled-components';
import ContentCard from '../../general/layouts/ContentCard';

export const ContentCardStyled = styled(ContentCard)`
  padding: 4rem;
  align-items: center;
`;

export const StepSubtitleStyled = styled.p`
  margin: 0;
  max-width: 55rem;
`;
